import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from 'shared/actions/authentication';
import { onConsultantCianCloseNoAuth, requestChat } from 'shared/actions/consultantCianChat';
import { selectUser } from 'shared/selectors';

export function useConsultantCianChat() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const handleOpenChat = React.useCallback(() => {
    if (!user?.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => requestChat(),
          onCloseNoAuth: () => onConsultantCianCloseNoAuth(),
        }),
      );

      return;
    }

    dispatch(requestChat());
  }, [dispatch, user]);

  return React.useMemo(
    () => ({
      handleOpenChat,
    }),
    [handleOpenChat],
  );
}
